import type * as React from 'react';

import { useLocation } from '@xing-com/crate-core-router';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { XingletLoader } from '@xing-com/crate-xinglet';

export const Container: React.FC = () => {
  const { isLoggedOut } = useLoginState();
  const location = useLocation();

  if (isLoggedOut) {
    return (
      <XingletLoader name="@xing-com/crate-profile-main-loader-logged-out" />
    );
  } else {
    // Check if this is the linkedin-auth route
    if (location.pathname.startsWith('/profile/data_imports')) {
      return <XingletLoader name="@xing-com/crate-profile-linkedin-auth" />;
    }

    return <XingletLoader name="@xing-com/crate-profile-main-logged-in" />;
  }
};
